import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useBillingFiscalDocumentGroupRemoveFiscalDocument from "../../hooks/useBillingFiscalDocumentGroupRemoveFiscalDocument";

export default function RemoveFiscalDocument({ groupId }: { groupId: string; }) {
  const queryClient = useQueryClient();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const { mutate: removeFiscalDocument } = useBillingFiscalDocumentGroupRemoveFiscalDocument({
    id: groupId,
    onSuccess: () => {
      setModalIsOpen(false);
      setIsError(false);
      queryClient.invalidateQueries({queryKey: ['billingFiscalDocumentGroup', groupId]})
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setModalIsOpen(false);
        setIsError(true);
        setMessages(error.response?.data.errors.base);
      }
    }
  });

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        Trigger={(
          <div className="flex items-center space-x-2">
            <Button
              operationKlassToCheckPermission="Admin::Billing::FiscalDocumentGroups::RemoveFiscalDocument"
              data-testid="remove_fiscal_document_groups_button"
            >
              Remover nota fiscal
            </Button>
          </div>
        )}
        title="Confirmar exclusão da Nota Fiscal"
        subtitle="Deseja realmente apagar esta Nota Fiscal? O lote voltará para o status Pendente e ficará aguardando novo upload."
        subtitleClassName="mt-2"
        titleClass="text-2xl"
        useCancellableFooter
        showClose={false}
        confirmButtonClassName="bg-danger"
        onConfirm={() => removeFiscalDocument()}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isError}
          onClose={() => {
            queryClient.invalidateQueries({ queryKey: ['billingFiscalDocumentGroup', groupId] });
            queryClient.invalidateQueries({ queryKey: ['billingFiscalDocumentGroups'] });
          }}
        />
      )}
    </>
  );
}
